import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Delete, Download } from '@tds/core-interactive-icon';
import Spinner from '@tds/core-spinner';
import axios from 'axios';

import Confirmation from './confirmation';
import request, { apiHost, config } from '../../../../../utils/request';

const FilesListRow = ({ fileData, removeFileFromList }) => {
  const { filename, id } = fileData;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const onDeleteFile = async () => {
    try {
      setConfirmDelete(false);
      setIsDeleting(true);
      const result = await request.delete(`/orders/delete-attachment/${id}`);
      if (result) {
        setIsDeleting(false);
        removeFileFromList(id);
      }
    } catch (error) {
      setIsDeleting(false);
      throw error;
    }
  };

  const onFileDownload = () => {
    // setExportingDefects(true);
    const fileExtension = filename
      .split('.')
      .pop()
      .toLowerCase();

    const url = `${apiHost}/orders/attachment/${id}`;
    axios
      .get(url, { ...config(), responseType: `application/${fileExtension}` })
      .then(response => {
        const data = Uint8Array.from(response.data.content.data);
        const blob = new Blob([data.buffer], {
          type: `application/${fileExtension}`
        });
        if (fileExtension === 'pdf') {
          const fileURL = URL.createObjectURL(blob);

          window.open(fileURL);
        } else {
          // Create a download link
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);

          // Set the download attribute with a suggested file name
          downloadLink.download = filename;

          // Append the link to the body and programmatically trigger the click event
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // Remove the link from the DOM
          document.body.removeChild(downloadLink);
        }
      })
      .catch(() => {});
  };

  return (
    <>
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {confirmDelete && (
          <Confirmation
            setConfirmDelete={setConfirmDelete}
            onDeleteFile={onDeleteFile}
            fileName={filename}
          />
        )}
        {!confirmDelete && (
          <Spinner label="" spinning={isDeleting} inline>
            <div style={{ backgroundColor: 'transparent' }}>{filename}</div>
            <div style={{ backgroundColor: 'transparent' }}>
              <Download onClick={onFileDownload} a11yText="Download" />
              <span style={{ margin: '0 0.5rem' }}></span>
              <Delete
                onClick={() => setConfirmDelete(true)}
                a11yText="Delete"
              />
            </div>
          </Spinner>
        )}
      </li>
    </>
  );
};

FilesListRow.propTypes = {
  fileData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  removeFileFromList: PropTypes.func.isRequired
};

export default FilesListRow;
